module.exports = __webpack_public_path__ + "images/3220e3148fd49711f63284a93486ffd3-IMG_0235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_0235.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_0235.jpg
// module chunks = 0